import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const usuEntidadesApi = `${baseUrl}/usuario-entidades`;

export const allUsuEntidadesService = async (params) => {
  const res = await axios.get(usuEntidadesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const oneUsuEntidadesService = async (id) => {
  const res = await axios.get(`${usuEntidadesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const searchUsuEntidadesService = async (params) => {
  const res = await axios.get(`${usuEntidadesApi}/search`, {
    headers: token({}),
    params,
  });
  return res;
};

export const deleteUsuEntidadesService = async (id) => {
  const res = await axios.delete(`${usuEntidadesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const createUsuEntidadesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${usuEntidadesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(usuEntidadesApi, data, {
      headers: token({}),
    });
  }
  return res;
};
